import * as moment from 'moment';
import getEnv, { isProd } from 'src/env/enviroment';
import { VerifyPolicyInput } from 'src/redux/reducer/v2/verifyPolicy';

interface GenerateCovieMetadataArgs {
  isValidVerifyPolicyInputData: boolean;
  verifyPolicyInputData: VerifyPolicyInput;
}

interface CovieMetadata {
  lastName: string;
  firstName: string;
  email: string;
  address: string;
  unit: string;
  leaseStartDate: string;
  leaseEndDate: string;
  policyNumber: string;
  policyProvider: string;
  policyEffectiveDate: string;
  policyExpirationDate: string;
  personalLiabilityCoverage: string;
  personalPropertyCoverage: string;
  medicalPayments: string;
  complianceStatus: string;
  correctName: string;
  correctAddress: string;
  correctDates: string;
  personalProperty: string;
  personalLiability: string;
  medicalIsCovered: string;
  autoCheckStatus: string;
  enivronment?: string;
}

export function generateCovieMetadata({
  isValidVerifyPolicyInputData,
  verifyPolicyInputData,
}: GenerateCovieMetadataArgs): CovieMetadata | undefined {
  if (!isValidVerifyPolicyInputData || !verifyPolicyInputData) {
    return undefined;
  }

  const covieMetadataAddress = `${
    verifyPolicyInputData.address.addressNumber || ''
  } ${verifyPolicyInputData.address.street || ''}, ${
    verifyPolicyInputData.address.municipality || ''
  },${verifyPolicyInputData.address.state || ''} ${
    verifyPolicyInputData.address.postalCode || ''
  }`;
  const leaseStartDate = moment
    .default(verifyPolicyInputData.leaseStart)
    .format('MM/DD/YYYY');
  const leaseEndDate = moment
    .default(verifyPolicyInputData.leaseEnd)
    .format('MM/DD/YYYY');

  const covieMetadata: CovieMetadata = {
    lastName: verifyPolicyInputData.lastName,
    firstName: verifyPolicyInputData.firstName,
    email: verifyPolicyInputData.email,
    address: covieMetadataAddress,
    unit: verifyPolicyInputData.buildingUnit,
    leaseStartDate: leaseStartDate,
    leaseEndDate: leaseEndDate,
    policyNumber: 'NULL',
    policyProvider: 'NULL',
    policyEffectiveDate: 'MM/DD/YYYY',
    policyExpirationDate: 'MM/DD/YYYY',
    personalLiabilityCoverage: 'NULL',
    personalPropertyCoverage: 'NULL',
    medicalPayments: 'NULL',
    complianceStatus: 'in-progress',
    correctName: 'NULL',
    correctAddress: 'NULL',
    correctDates: 'NULL',
    personalProperty: 'NULL',
    personalLiability: 'NULL',
    medicalIsCovered: 'NULL',
    autoCheckStatus: 'NULL',
  };

  if (!isProd) {
    const currentEnv = getEnv().ren_env;
    covieMetadata.enivronment = currentEnv;
  }

  return covieMetadata;
}
